import { WbSearch } from '../../../WbSearch';
import { CommonFilters } from './types';

interface SearchFilterProps<T> {
  value: string;
  changeFilters: <K extends keyof T>(key: K, value: T[K]) => void;
  filterKey?: string;
}

export const SearchFilter = <T extends CommonFilters>({
  value,
  changeFilters,
  filterKey,
}: SearchFilterProps<T>) => {
  return (
    <WbSearch
      fullWidth={false}
      value={value}
      onChange={(search: string) =>
        changeFilters((filterKey as any) ?? 'search', search)
      }
      debounced
    />
  );
};
